import type { CSSProperties, Ref } from 'react';
import { forwardRef } from 'react';
import type { TextAlignProps } from 'styled-system';

import type { BoxProps, ResponsiveValue } from '@/components/Box';
import { theme } from '@/theme';
import type {
  FontFamiliesAliases,
  FontSizes,
  FontWeights,
  LineHeights,
} from '@/theme/types';

import * as S from './Text.styles';

export interface TextProps
  extends TextAlignProps, BoxProps, Pick<CSSProperties, 'whiteSpace'> {
  after?: string;
  before?: string;
  // todo: improve typing
  fontFamily?: FontFamiliesAliases;
  fontSize?: ResponsiveValue<FontSizes>;
  fontStyle?: 'normal' | 'italic';
  fontWeight?: ResponsiveValue<FontWeights>;
  lineHeight?: ResponsiveValue<LineHeights>;
  textDecoration?: 'line-through' | 'underline' | 'none';
  textTransform?: 'uppercase' | 'lowercase' | 'capitalize' | 'none';
}

export const Text = forwardRef((props: TextProps, ref: Ref<HTMLElement>) => {
  const { as, fontFamily, ...rest } = props;

  return (
    <S.Text
      ref={ref}
      fontFamily={fontFamily ? theme.fontFamilies[fontFamily] : undefined}
      forwardedAs={as}
      {...rest}
    />
  );
});

Text.defaultProps = {
  as: 'p',
  fontSize: 'p2',
  lineHeight: 'p2',
};

Text.displayName = 'Text';
